/**
 * The balance as a picker option's trailing figure — mono, two decimals, a muted zero, and RED
 * when below zero, the one state in it that asks for attention.
 */
export function LeaveBalanceFigure({ value }: { value: number | null }) {
  if (value == null) return null;

  const tone = value < 0 ? 'text-red-600' : value === 0 ? 'text-slate-300' : 'text-slate-500';

  return (
    <span className={`font-mono tabular-nums ${tone}`}>
      {value.toFixed(2)}
      <span className="sr-only"> days left</span>
    </span>
  );
}
